import './Theme.Collection.Table.scss';
export default 'ThemeCollectionTable';
